module.exports = __webpack_public_path__ + "img/vertical_6_4_7042.4426205a.png";